import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "hydrao-nav-button",
  templateUrl: "./nav-button.component.html",
  styleUrls: ["./nav-button.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatIconModule],
})
export class NavButtonComponent {
  public label = input<string>();
  public subLabel = input<string>();
  public icon = input<string>();
  public svgicon = input<string>();
  public selected = input<boolean>(false);
  public reduced = input<boolean>(false);

  constructor() {}
}
